export class Invoice {
  constructor(
    public documentSerie: string,
    public base: number,
    public vat: number,
    public invoiceFileUrl: string,
    public total: number,
    public date: string
  ){}
}



// WEBPACK FOOTER //
// /home/usr/clienti.qmedical/src/app/models/invoice.ts